import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export default CloseRoundedIcon;
